import {
  GET_TOURNAMENTS_LIST,
  GET_PLAYER_LEADERBOARD,
  GET_TEAM_LEADERBOARD,
} from 'constants/actionTypes';

const defaultState = {
  tournamentsList: [],
  playerLeaderBoard: [],
  teamLeaderBoard: [],
};

function leaderBoardReducer(state = defaultState, action) {
  switch (action.type) {
    case GET_TOURNAMENTS_LIST: {
      const list = action.payload;
      return {
        ...state,
        tournamentsList: list,
      };
    }
    case GET_TEAM_LEADERBOARD: {
      return {
        ...state,
        teamLeaderBoard: action.payload,
      };
    }
    case GET_PLAYER_LEADERBOARD: {
      return {
        ...state,
        playerLeaderBoard: action.payload,
      };
    }
    default:
      return state;
  }
}

export default leaderBoardReducer;
